import "./banner.css"
import ellipse from "../../assets/images/ellipse.png"
import doctor from "../../assets/images/banner-doctor.png"
import { useTranslation } from "react-i18next";

const Banner = () => {
    const { t } = useTranslation();
    const title = t("banner.title");
    return (
        <div className="banner-container">

            <div className="banner-content">

                <div className="banner-heading">
                    <h2>{title.split("\n").map((line, i) => (<span key={i}>{line}<br /></span>))}</h2>
                </div>

                <div className="banner-subheading">
                    <p>{t("banner.subtitle")}</p>
                </div>

                <div className="banner-buttons">
                    <button className="banner-appointment-button" onClick={() => window.location.href = '/appointments'}>{t("banner.request")}</button>
                    <button className="banner-learn-button" onClick={() => window.location.href = '/doctor'}>{t("banner.learn")}</button>
                </div>

            </div>

            <div className="banner-graphic">
                <img src={ellipse} alt="ellipse" />
                <img src={doctor} alt="doctor" />
            </div>

        </div>
    )
}

export default Banner